var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgChatTip = function SvgChatTip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4973"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4974",
    transform: "translate(-15 -247)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "63f0acc0950f1630054ee28947c869bb",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(15 247)",
    fill: "#ffad4e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-md-bulb",
    d: "M31.157 277.326a1.2 1.2 0 001.2 1.2h5.283a1.2 1.2 0 001.2-1.2v-1.08h-7.683zm3.842-21.853c-4.785 0-8.645 3.6-8.645 8.045a7.94 7.94 0 003.686 6.64v2.605a1.2 1.2 0 001.239 1.153h7.438a1.2 1.2 0 001.237-1.153v-2.605a7.931 7.931 0 003.692-6.64c-.002-4.445-3.862-8.045-8.647-8.045z",
    fill: "#fff"
  })))));
};
export default SvgChatTip;